import LanguageProvider from '@base/LanguageProvider';
import { TagContextProvider } from '@data/tag/tagContext';
import Overlay from '@shared/popover/Overlay';
import TitleTooltip from '@shared/popover/TitleTooltip';
import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom';
import { queryClient } from '../../App';
import { AuthContextProvider } from '../../providers/AuthProvider';
var modalNodes = [];
var popoverNodes = [];
var infoNodes = [];
var menuNode = null;
var errBanner = null;
function renderModal(Component) {
    var node = document.createElement('div');
    document.body.appendChild(node);
    ReactDOM.render(React.createElement(QueryClientProvider, { client: queryClient, contextSharing: true },
        React.createElement(AuthContextProvider, { ignore: true },
            React.createElement(LanguageProvider, null,
                React.createElement(TagContextProvider, null, Component)))), node);
    modalNodes.push(node);
}
function closeModal() {
    if (modalNodes.length > 0) {
        var top = modalNodes.pop();
        if (!top) {
            return;
        }
        ReactDOM.unmountComponentAtNode(top);
        document.body.removeChild(top);
    }
}
function renderPopover(Component) {
    var scrollTop = window.scrollY;
    var node = document.createElement('div');
    document.body.appendChild(node);
    ReactDOM.render(Component, node);
    window.scrollTo(0, scrollTop);
    popoverNodes.push(node);
}
function closePopover() {
    if (popoverNodes.length > 0) {
        var top = popoverNodes.pop();
        if (!top) {
            return;
        }
        ReactDOM.unmountComponentAtNode(top);
        document.body.removeChild(top);
    }
}
function closeMenu() {
    if (menuNode) {
        ReactDOM.unmountComponentAtNode(menuNode);
        document.body.removeChild(menuNode);
        menuNode = null;
    }
}
function renderMenu(Component) {
    closeMenu();
    var node = document.createElement('div');
    document.body.appendChild(node);
    ReactDOM.render(Component, node);
    menuNode = node;
}
function renderInfo(Component) {
    var node = document.createElement('div');
    document.body.appendChild(node);
    ReactDOM.render(Component, node);
    infoNodes.push(node);
}
function closeInfo() {
    if (infoNodes.length > 0) {
        var top = infoNodes.pop();
        if (!top) {
            return;
        }
        ReactDOM.unmountComponentAtNode(top);
        document.body.removeChild(top);
    }
}
function renderTitle(placement, target, msg) {
    if (!target) {
        return;
    }
    var tooltip = (React.createElement(Overlay, { placement: placement, targetNode: target },
        React.createElement(TitleTooltip, { msg: msg })));
    renderPopover(tooltip);
}
function renderBanner(Component) {
    closeBanner();
    var node = document.createElement('div');
    document.body.appendChild(node);
    ReactDOM.render(Component, node);
    errBanner = node;
}
function closeBanner() {
    if (errBanner) {
        ReactDOM.unmountComponentAtNode(errBanner);
        document.body.removeChild(errBanner);
        errBanner = null;
    }
}
export default {
    renderModal: renderModal,
    closeModal: closeModal,
    renderPopover: renderPopover,
    closePopover: closePopover,
    renderInfo: renderInfo,
    closeInfo: closeInfo,
    renderTitle: renderTitle,
    renderMenu: renderMenu,
    closeMenu: closeMenu,
    renderBanner: renderBanner,
    closeBanner: closeBanner,
};
